Vue.component("order-list-component", require("./Index.vue").default);
Vue.component("order-show-component", require("./Show.vue").default);
Vue.component("order-show-sign-route", require("./ShowOrder.vue").default);
